import { useTranslation } from 'react-i18next'

import { Dialog } from '@/components/ui'

import { Form } from './Form'
import { CartItemOrderEditModalProps } from './type'

export const CartItemOrderEditModal = ({
  cartItem,
  disabled,
  isVisiblePurchasePrice,
  isOpen,
  isSubmittingDelete,
  isSubmittingEdit,
  onSubmit,
  onClose,
  onDelete,
}: CartItemOrderEditModalProps) => {
  const { t } = useTranslation()
  return (
    <Dialog title={t('order.action.editContent')} isOpen={isOpen}>
      <Form
        cartItem={cartItem}
        disabled={disabled}
        isSubmittingEdit={isSubmittingEdit}
        isSubmittingDelete={isSubmittingDelete}
        isVisiblePurchasePrice={isVisiblePurchasePrice}
        onSubmit={onSubmit}
        onClose={onClose}
        onDelete={onDelete}
      />
    </Dialog>
  )
}
